// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorAccountPharmacyBenefitModels {
    static getAttributeTypeMap() {
        return PayorAccountPharmacyBenefitModels.attributeTypeMap;
    }
}
PayorAccountPharmacyBenefitModels.discriminator = undefined;
PayorAccountPharmacyBenefitModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<PayorAccountPharmacyBenefitModel>"
    }
];
//# sourceMappingURL=payorAccountPharmacyBenefitModels.js.map